import { type MutationError, trpc } from '@/shared/api';

interface UseUpdateBasicInfoOptions {
  readonly onSuccess?: () => void;
}

/** 기본 정보 섹션 저장. */
export const useUpdateBasicInfo = ({ onSuccess }: UseUpdateBasicInfoOptions = {}) => {
  const mutation = trpc.productManagement.products.updateBasicInfo.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    updateBasicInfo: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
